import React from "react"
import styles from "./blockImgTitleTextRight.module.css"
const BlockImgTitleTextRight = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data
  return (
    <section className={styles.blockImgTitleTextRight}>
      <div className={styles.blockImgTitleTextRight__img}>
        <img src={`https://drupal.smartempo.com${image}`} alt="" />
      </div>
      <div className={styles.blockImgTitleTextRight__titleText}>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </section>
  )
}
export default BlockImgTitleTextRight
